import localforage from "localforage";
import Depot from "@/models/Depot";

export const LOCALFORAGE_DB = "Rentrunner";
export const LOCALFORAGE_STORE = "RentrunnerDB";

const configure = () => {
  localforage.config({
    driver: localforage.INDEXEDDB,
    name: LOCALFORAGE_DB,
    version: 1.0,
    storeName: LOCALFORAGE_STORE,
    description: "Local DB storage for various models"
  });
};

configure();

export default configure;

export const LocalForageKey = {
  INITIAL_SEARCH_DEPOTS: "INITIAL_SEARCH_DEPOTS",
  INITIAL_SEARCH_TIMESTAMPS: "INITIAL_SEARCH_TIMESTAMPS"
};

export class Localforage {
  static writesEnabled = true;

  static enableWrites() {
    Localforage.writesEnabled = true;
  }

  static clearAll() {
    Localforage.writesEnabled = false;

    return localforage
      .ready()
      .catch(() => null)
      .then(() => localforage.clear())
      .catch(() =>
        Promise.all([
          localforage.removeItem(LocalForageKey.INITIAL_SEARCH_DEPOTS),
          localforage.removeItem(LocalForageKey.INITIAL_SEARCH_TIMESTAMPS)
        ])
      );
  }

  static getDepots(key = "general") {
    return new Promise((resolve, reject) => {
      localforage.getItem(LocalForageKey.INITIAL_SEARCH_DEPOTS, (err, val) => {
        val = val || {};
        resolve(Depot.list(val[key] || []));
      });
    });
  }

  static saveDepots(depots, key, timestamp) {
    if (!Localforage.writesEnabled) return Promise.resolve();

    return Localforage.setTs(timestamp, key).then(() => {
      return Localforage.setDepots(depots, key);
    });
  }

  /* getItem(key, callback) resolves with the read, so writing from inside it left
     callers awaiting the read while the write was still in flight. */
  static setDepots(depots, key) {
    if (!Localforage.writesEnabled) return Promise.resolve();

    return localforage
      .getItem(LocalForageKey.INITIAL_SEARCH_DEPOTS)
      .then(val => {
        val = val || {};
        val[key || "general"] = depots;

        return localforage.setItem(LocalForageKey.INITIAL_SEARCH_DEPOTS, val);
      });
  }

  static deleteDepotIds(ids, key, ts) {
    return new Promise((resolve, reject) => {
      return Localforage.getDepots(key).then(depots => {
        depots = depots.filter(item => ids.indexOf(item.id) == -1);

        Localforage.saveDepots(depots, key).then(() => {
          resolve(depots);
        });
      });
    });
  }

  static updateDepots(depotsUpdated, key, ts) {
    return new Promise((resolve, reject) => {
      return Localforage.getDepots(key).then(depots => {
        depotsUpdated.forEach(depot => {
          const index = depots.findIndex(item => item.id == depot.id);
          if (index > -1) depots[index] = depot;
          else depots.push(depot);
        });

        Localforage.saveDepots(depots, key, ts).then(() => {
          resolve(depots);
        });
      });
    });
  }

  static getTs(key = "general") {
    return new Promise((resolve, reject) => {
      localforage.getItem(
        LocalForageKey.INITIAL_SEARCH_TIMESTAMPS,
        (err, val) => {
          val = val || {};

          resolve(val[key]);
        }
      );
    });
  }

  static setTs(timestamp, key) {
    if (!Localforage.writesEnabled) return Promise.resolve();

    return localforage
      .getItem(LocalForageKey.INITIAL_SEARCH_TIMESTAMPS)
      .then(val => {
        val = val || {};
        if (timestamp) {
          val[key || "general"] = timestamp;
        }

        return localforage.setItem(
          LocalForageKey.INITIAL_SEARCH_TIMESTAMPS,
          val
        );
      });
  }
}
